<template lang="pug">
  BaseForm(
    :title="title"
    :routeKey="routeKey"
    :routes="routes"
    :form="form"
    :data="item"
    :update="updateItem"
    :create="createItem"
  )
</template>

<script>
import BaseForm from '@/components/app/BaseForm'
import { mapState, mapActions } from 'vuex'
import store from '@/store'

export default {
  components: { BaseForm },
  data: (vm) => ({
    title: vm.$t('products.edit', { id: vm.$route.params.productId })
  }),
  computed: {
    ...mapState('products', ['routeKey', 'routes', 'form', 'item']),
    crumbs: vm => [
      { text: vm.$t('products.title'), to: { name: 'products.index' } },
      { text: vm.$t('products.edit', { id: vm.$route.params.productId }) }
    ]
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('products/fetchItem', { route: to })
      await store.dispatch('products/fetchEnums')
      await store.dispatch('products/fetchSiteVersions')
      next()
    } catch (error) {
      next(error)
    }
  },
  methods: {
    ...mapActions('products', ['createItem', 'updateItem'])
  }
}
</script>
